import { render, staticRenderFns } from "./BlackRecordConsumeV2.vue?vue&type=template&id=270b2c2d&scoped=true"
import script from "./BlackRecordConsumeV2.vue?vue&type=script&lang=js"
export * from "./BlackRecordConsumeV2.vue?vue&type=script&lang=js"
import style0 from "./BlackRecordConsumeV2.vue?vue&type=style&index=0&id=270b2c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b2c2d",
  null
  
)

export default component.exports